import { Link, useNavigate, useParams } from "react-router-dom"
import MainLayout from "../../components/layouts/MainLayout"
import { useEffect, useState } from "react"
import { providerApi } from "../../api/providerApi"
import { Alert, Spin, Collapse, Card } from "antd"
import { PlusCircleOutlined, MinusCircleOutlined, LeftCircleOutlined } from '@ant-design/icons';
import { ClientApi } from "../../api/clientApi"
import { categoryApi } from "../../api/categoryApi"
const { Panel } = Collapse;

const ShowCategoryView = () => {
    const {id} = useParams()
    const [category, setCategory] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null);
    const abortController = new AbortController()
    const navigate = useNavigate()
    
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString();
      };

    useEffect(() => {
        // Définir la fonction fetchCategory à l'intérieur de useEffect
        const fetchCategory = async () => {
          setLoading(true);
          setError(null);
          try {
            const res = await categoryApi.getCategory(`${id}`,abortController.signal);
            setCategory(res.data.category); // Stocker les données récupérées

            console.log("details",res.data)
          } catch (err) {
            setError("Impossible de charger les détails du mécano.");
          } finally {
            setLoading(false);
          }
        };
    
        fetchCategory(); // Appeler la fonction immédiatement
    
      }, [id]);
      


    return <MainLayout>
    <div className="container mx-auto p-6">
        <div className="flex justify-between">
            <h1 className="text-3xl font-semibold mb-6">Détails de la categorie</h1>
            <Link to={`/annonces/categories`}><LeftCircleOutlined/> Retour  </Link>
        </div>

      {loading && <Spin size="large" />}
      {error && <Alert message={error} type="error" />}
      {!loading && !error && category && (
        <div className="bg-white p-6 rounded-lg shadow-md">
          {/* Information personnelle */}
          <Collapse defaultActiveKey={['1']} expandIconPosition="start">
            <Panel header="Informations complementaires" key="1" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <p><strong>Nom de la categorie:</strong> {category.libelle}</p>
                <p><strong>description :</strong> {category.description || "Non fourni"}</p>
                <p><strong>Nombre d'abonnee :</strong> {category.is_followed || 0}</p>
                

                <p><strong>Date d'ajout :</strong> {formatDate(category.created_at)}</p>
              </div>
            </Panel>
          </Collapse>

          {/* Information sur les contacts */}
          <Collapse defaultActiveKey={['2']} expandIconPosition="start" className="mt-4">
            <Panel header="Informations supplementaires" key="2" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <p><strong>Etat :</strong> {category.etat === 1 ? "Actif" : " Inactif"}</p>
                <p><strong>Status :</strong> {category.parent_id === 0 && "Categorie principale"}</p>

              </div>
            </Panel>
          </Collapse>

        </div>
      )}
    </div>
  </MainLayout>

}
export default ShowCategoryView